import styled from 'styled-components'
import Icon from '@/components/icon'
import { createModal, useModalize } from '@/components/modalize/mui'
import { breakpoints } from '@/styles'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 25px 10px;
  }
`

const ContentWrapper = styled.div``

const CloseButton = styled(Icon)`
  position: absolute;
  z-index: 1;
  cursor: pointer;
  top: 0px;
  right: 5px;
  height: 52px;
  width: 52px;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    top: 5px;
    right: -5px;
    height: 40px;
    width: 40px;
  }
`

const ModalImage = styled.img`
  height: auto;
  max-height: calc(95vh - 50px);
  width: 100%;
`

const ImageModal = ({ src }) => {
  const { close } = useModalize()
  return (
    <Wrapper>
      <CloseButton aria-label="Close" id="close_button" onClick={close} />
      <ContentWrapper>
        <a href={src} rel="noreferrer noopener" target="_blank">
          <ModalImage src={src} data-hj-suppress />
        </a>
      </ContentWrapper>
    </Wrapper>
  )
}

export const showImageModal = createModal(ImageModal, {
  showClose: false,
  width: 'max-content',
  maxWidth: 'calc(100vw - 40px)',
  maxHeight: '100vh',
  radius: 0,
  bgColor: 'rgba(0, 0, 0, 0)',
  overflow: 'visible',
  isVideo: true
})
